// extracted by mini-css-extract-plugin
export default {"formContainer":"RecipesForm_formContainer__CRl-c"};